export const parsePriceToPln = (value) => {
  value = value.toString();
  let firstSide = value.slice(0, value.length - 2);
  let secondSide = value.slice(value.length - 1, value.length);
  value = firstSide + "." + secondSide + secondSide;
  return value
}